<template>
  <div class="card">
    <!-- modal -->

    <modal
      name="informe"
      :scrollable="true"
      :draggable="false"
      width="700"
      height="auto"
      :reset="true"
      v-if="informacionPaciente != ''"
    >
      <br />
      <div>
        <div>
          <div class="modal-header" style="padding-right: 5px; padding-top: 0">
            <div class="row">
              <div class="col-md-1">
                <i class="fa fa-file text-success" style="font-size: 37px"></i>
              </div>
              <div class="col-md-7">
                <p class="titulo-modal">
                  Generar informe de evolución de -
                  <strong>
                    {{
                    informacionPaciente[0].PacNom1 +
                    " " +
                    informacionPaciente[0].PacApe1
                  }}
                  </strong>
                </p>
                <p class="texto-pequeno">
                  Formulario de exportanción de informe
                </p>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <label for="">Fecha inicio:</label>
                <input
                  type="text"
                  readonly
                  class="form-control"
                  v-model="fechainicio"
                />
              </div>
              <div class="col-md-6">
                <label for="">Fecha fin:</label>
                <input
                  type="text"
                  readonly
                  class="form-control"
                  v-model="fechafin"
                />
              </div>
            </div>
            <div class="row">
              <br />
              <div class="col-md-12">
                <label for="">Resumen:</label>
                <textarea
                  v-model="resumen"
                  cols="30"
                  rows="10"
                  :maxlength="configInput.MAX_CHARTERS"
                  class="form-control"
                ></textarea>
                <span
                  v-bind:class="{
                    'text-danger': resumen.length == configInput.MAX_CHARTERS,
                  }"
                  >{{ resumen.length }} / {{ configInput.MAX_CHARTERS }}
                  <small
                    v-bind:class="{
                      'd-none': resumen.length < configInput.MAX_CHARTERS,
                    }"
                  >
                    - Solo se permiten
                    {{ configInput.MAX_CHARTERS }} caracteres</small
                  >
                </span>
                <br />
              </div>
            </div>
          </div>
          <div class="modal-footer" style="padding-bottom: 0">
            <!-- <center> -->

              <button
              type="button"
              style="border-radius: 7px;"
              class="btn btn-danger"
              @click="cerrarModal()"
            >
              <i class="fa fa-close"></i> CERRAR
            </button>

            <button
              type="button"
              style="border-radius: 7px;"
              class="btn btn-success btn-fill"
              @click="generarInformeDeEvolucion()"
            >
              <i class="fa fa-file"></i> GENERAR INFORME
            </button>

            

            <!-- </center> -->
          </div>
          <br />
        </div>
      </div>
    </modal>
    <!-- fin modal -->

    <!-- modal informe por paciente -->
    <modal
      name="informeporpaciente"
      :scrollable="true"
      :draggable="false"
      width="700"
      height="auto"
      :reset="true"
      v-if="informacionPaciente != ''"
    >
      <br />
      <div>
        <div>
          <div class="modal-header" style="padding-right: 5px; padding-top: 0">
            <div class="row">
              <div class="col-md-1">
                <i class="fa fa-file text-success" style="font-size: 37px"></i>
              </div>
              <div class="col-md-7">
                <p class="titulo-modal">
                  Generar informe por paciente de -
                  <strong>
                    {{
                    informacionPaciente[0].PacNom1 +
                    " " +
                    informacionPaciente[0].PacApe1
                  }}
                  </strong>
                </p>
                <p class="texto-pequeno">
                  Formulario de exportanción de informe
                </p>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <label for="">Mes:</label>
                <select v-model="mes" class="form-control">
                  <option value="Enero">Enero</option>
                  <option value="Febrero">Febrero</option>
                  <option value="Marzo">Marzo</option>
                  <option value="Abril">Abril</option>
                  <option value="Mayo">Mayo</option>
                  <option value="Junio">Junio</option>
                  <option value="Julio">Julio</option>
                  <option value="Agosto">Agosto</option>
                  <option value="Septiembre">Septiembre</option>
                  <option value="Octubre">Octubre</option>
                  <option value="Noviembre">Noviembre</option>
                  <option value="Diciembre">Diciembre</option>
                </select>
              </div>
            </div>
            <div class="row">
              <br />
              <div class="col-md-12">
                <label for="">Especialidad</label>
                <select v-model="especialidad" class="form-control">
                  <option value="Psicología">Psicología</option>
                  <option value="Fonoaudiología">Fonoaudiología</option>
                  <option value="Terapia Ocupacional">
                    Terapia Ocupacional
                  </option>
                  <option value="Educación Especial">Educación Especial</option>
                  <option value="Fisioterapia">Fisioterapia</option>
                </select>
              </div>
              <div class="col-md-12">
                <label for="">Concepto:</label>
                <textarea
                  v-model="concepto"
                  cols="30"
                  rows="5"
                  :maxlength="configInput.MAX_CHARTERS"
                  class="form-control"
                ></textarea>
                <span
                  v-bind:class="{
                    'text-danger': concepto.length == configInput.MAX_CHARTERS,
                  }"
                  >{{ concepto.length }}/ {{ configInput.MAX_CHARTERS }}
                  <small
                    v-bind:class="{
                      'd-none': concepto.length < configInput.MAX_CHARTERS,
                    }"
                  >
                    - Solo se permiten
                    {{ configInput.MAX_CHARTERS }} caracteres</small
                  >
                </span>
                <br />
              </div>

              <div class="col-md-12">
                <br />
                <label for="">Recomendación:</label>
                <textarea
                  v-model="recomendacion"
                  cols="30"
                  rows="5"
                  :maxlength="configInput.MAX_CHARTERS"
                  class="form-control"
                ></textarea>
                <span
                  v-bind:class="{
                    'text-danger':
                      recomendacion.length == configInput.MAX_CHARTERS,
                  }"
                  >{{ recomendacion.length }}/ {{ configInput.MAX_CHARTERS }}
                  <small
                    v-bind:class="{
                      'd-none': recomendacion.length < configInput.MAX_CHARTERS,
                    }"
                  >
                    - Solo se permiten
                    {{ configInput.MAX_CHARTERS }} caracteres</small
                  >
                </span>
                <br />
              </div>
            </div>
          </div>
          <div class="modal-footer" style="padding-bottom: 0">
            <!-- <center> -->

              <button
              type="button"
              style="border-radius: 7px;"
              class="btn btn-danger"
              @click="cerrarModal()"
            >
              <i class="fa fa-close"></i> CERRAR
            </button>

            <button
              type="button"
               style="border-radius: 7px;"
              class="btn btn-success btn-fill"
              @click="generarInformePaciente()"
            >
              <i class="fa fa-file"></i> GENERAR INFORME
            </button>

           

            <!-- </center> -->
          </div>
          <br />
        </div>
      </div>
    </modal>
    <!-- fin modal  -->

    <!-- MODAL INFORME OYL -->

    <modal
      name="informeOyL"
      :scrollable="false"
      :draggable="false"
      width="700"
      height="auto"
      :reset="true"
    >
      <br />
      <div>
        <div>
          <div class="modal-header" style="padding-right: 5px; padding-top: 0">
            <div class="row">
              <div class="col-md-1">
                <i class="fa fa-file text-success" style="font-size: 37px"></i>
              </div>
              <!-- <div class="col-md-7">
                <p class="titulo-modal">
                  INFORME DE EVOLUCIÓN -
                  {{
                    informacionPaciente[0].PacNom1 +
                    " " +
                    informacionPaciente[0].PacApe1
                  }}
                </p>
                <p class="texto-pequeno">
                  Formulario de exportanción de informe
                </p>
              </div> -->
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <label for="">Fecha inicio:</label>
                <input
                  type="text"
                  readonly
                  class="form-control"
                  v-model="fechainicio"
                />
              </div>
              <div class="col-md-6">
                <label for="">Fecha fin:</label>
                <input
                  type="text"
                  readonly
                  class="form-control"
                  v-model="fechafin"
                />
              </div>
            </div>
            <div class="row">
              <br />
              <div class="col-md-12">
                <label for="">Resumen:</label>
                <textarea
                  v-model="resumen"
                  cols="30"
                  rows="10"
                  maxlength="1000"
                  class="form-control"
                ></textarea>
                <span v-bind:class="{ 'text-danger': resumen.length == 1000 }"
                  >{{ resumen.length }}/1000
                  <small v-bind:class="{ 'd-none': resumen.length < 1000 }">
                    - Solo se permiten 1000 caracteres</small
                  >
                </span>
                <br />
              </div>
            </div>
          </div>
          <div class="modal-footer" style="padding-bottom: 0">
            <!-- <center> -->
              <button
              type="button"
              style="border-radius:7px"
              class="btn btn-danger"
              @click="cerrarModal()"
            >
              <i class="fa fa-close"></i> CERRAR
            </button>

            <button
              type="button"
              style="border-radius: 7px;"
              class="btn btn-success btn-fill"
              @click="generatePDFOyL()"
            >
              <i class="fa fa-file"></i> GENERAR INFORME
            </button>

           

            <!-- </center> -->
          </div>
          <br />
        </div>
      </div>
    </modal>
    <!-- FIN MODAL -->

    <div class="card-header">
      <center>
        <h4>Informes</h4>
      </center>
    </div>
    <div class="card-content">
      <div class="row">
        <div class="col-md-4">
          <label for="">Tipo de informe</label>
          <select @change="reset()" v-model="informe" class="form-control">
            <option value="1">Informe de evolución</option>
            <option value="2">Informe por paciente</option>
            <!-- <option value="3">Informe objetivos y logros</option> -->
          </select>
        </div>
      </div>
      <div class="row" v-if="informe == 1">
        <br />
        <div class="col-md-4">
          <label for="">Especialidad:</label>
          <select v-model="especialidadEvo" class="form-control">
            <option value="Todas">Todas</option>
            <option value="Terapia ocupacional">Terapia Ocupacional</option>
            <option value="Psicología">Psicología</option>
            <option value="Fonoaudiología">Fonoaudiología</option>
            <option value="Fisioterapia">Fisioterapia</option>
            <option value="Educación Especial">Educación Especial</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <label for="">Paciente:</label>
          <select v-model="paciente" class="form-control">
            <option value="">Seleccionar paciente....</option>
            <option
              :value="paciente.PacIdeUsu"
              v-for="paciente in pacienteSelect"
              :key="paciente.PacIdeUsu"
            >
              {{ paciente.PacNom1 + " " + paciente.PacApe1 }}
            </option>
          </select>
        </div>
        <div class="col-md-3" v-if="informe != 2">
          <label for="">Fecha inicio:</label>
          <input type="date" v-model="fechainicio" class="form-control" />
        </div>
        <div class="col-md-3" v-if="informe != 2">
          <label for="">Fecha fin:</label>
          <input type="date" v-model="fechafin" class="form-control" />
        </div>
        <div class="col-md-2">
          <label for="">Acciones</label> <br />
          <button
            class="btn btn-success btn-fill"
            style="border-radius: 5px"
            @click="getInforme()"
          >
            <i class="fa fa-search"></i> Buscar
          </button>
        </div>
      </div>
      <div class="row">
        <br />
        <div class="col-md-4" v-if="informe == 1">
          <button
            class="btn btn-success btn-fill"
            style="border-radius: 5px"
            @click="abrirModalGenerarPDF()"
            v-if="pdf == true"
          >
            Generar Informe de evolución <i class="fa fa-file"></i>
          </button>
        </div>
        <div class="col-md-4" v-if="informe == 2">
          <br />
          <button
            class="btn btn-success btn-fill"
            style="border-radius: 5px"
            @click="abrirModalGenerarInforme()"
            v-if="pdf == true"
          >
            Generar Informe por paciente <i class="fa fa-file"></i>
          </button>
        </div>
        <div class="col-md-4" v-if="informe == 3">
          <br />
          <button
            class="btn btn-success btn-fill"
            style="border-radius: 5px"
            @click="abrirModalGenerarInformeOyL()"
            v-if="pdf == true"
          >
            Generar Informe OyL <i class="fa fa-file"></i>
          </button>
        </div>
      </div>
      <div v-if="informacionPaciente != ''" class="row" style="margin: 3px">
        <br />
        <table class="table table-striped table-sm table-bordered">
          <thead>
            <tr>
              <th>Paciente</th>
              <th>Documento</th>
              <th>Fecha de nacimiento</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {{
                  informacionPaciente[0].PacNom1 +
                  " " +
                  informacionPaciente[0].PacApe1
                }}
              </td>
              <td>
                {{ informacionPaciente[0].PacNumDoc }}
              </td>
              <td>
                {{ informacionPaciente[0].PacFecNac }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="row"
        v-if="informe == 1 && terapias != ''"
        ref="evoluciones"
        style="margin: 3px"
      >
        <br />
        <table
          id="mi-table"
          class="mi-table table table-striped table-sm table-bordered"
        >
          <thead>
            <tr>
              <th>Fecha de atención</th>
              <th>Terapeuta</th>
              <th>Especialidad</th>
              <th>Estrategia terapéutica</th>
              <th>Lugar</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="terapia in terapias"
              :key="terapia.ProIde"
              v-if="
                (terapia.ProEst == 1 && especialidadEvo == terapia.TerIde) ||
                especialidadEvo == 'Todas'
              "
            >
              <td>
                {{ terapia.ProFec }}
              </td>
              <td>
                {{ terapia.terapeuta }}
              </td>
              <td>
                {{ terapia.TerIde }}
              </td>
              <td>
                {{ terapia.estrategia }}
              </td>
              <td>
                {{ terapia.ProLug }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="row"
        v-if="informe == 3 && objetivos != ''"
        ref="objetivos"
        style="margin: 3px"
      >
        <br />
        <table
          id="objetivoss"
          class="objetivoss table table-striped table-sm table-bordered"
        >
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Fecha a cumplir</th>
              <th>Terapeuta</th>
              <th>Especialidad</th>
              <th>Objetivo</th>
              <th>Logro</th>
              <th>Logro en %</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="objetivo in objetivos" :key="objetivo.ProIde">
              <td>
                <center>{{ objetivo.ObjFec }}</center>
              </td>
              <td>
                <center>{{ objetivo.ObjFecCum }}</center>
              </td>
              <td>
                {{ objetivo.ObjUsu }}
              </td>
              <td>
                <center>
                  <p v-if="objetivo.ObjTer == 1">Fisioterapia</p>
                  <p v-if="objetivo.ObjTer == 2">Fonoaudiología</p>
                  <p v-if="objetivo.ObjTer == 3">Terapia ocupacional</p>
                  <p v-if="objetivo.ObjTer == 4">Psicología</p>
                  <p v-if="objetivo.ObjTer == 5">Edu. Especial</p>
                </center>
              </td>
              <td>
                <center>
                  {{ objetivo.ObjObj }}
                </center>
              </td>
              <td>
                <center>
                  <span
                    v-if="
                      fechaActual > objetivo.ObjFecCum &&
                      objetivo.ObjLog == null
                    "
                    >Logro en proceso de confirmación</span
                  >
                  <span v-else>{{ objetivo.ObjLog }}</span>
                </center>
              </td>
              <td>
                <center>
                  <p v-if="objetivo.ObjLog == null">Sin evaluar</p>
                  <p v-else>{{ objetivo.ObjPor }}%</p>
                </center>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { Option } from "element-ui";

export default {
  data: () => ({
    pacienteSelect: [],
    paciente: "",
    informacionPaciente: "",
    ip: "https://avanti-erp.com/",
    fechainicio: "",
    fechafin: "",
    pdf: false,
    terapias: [],
    resumen: "",
    realizadas: 0,
    canceladas: 0,
    mes: "Enero",
    especialidadEvo: "Todas",
    especialidad: "Psicología",
    concepto: "",
    recomendacion: "",
    logo: "",
    informe: 1,
    cabecera_rosa: "",
    objetivos: [],
    cabecera_oyl: "",
    dx: "",
    fechaActual: "",
    indice: 0,
    usuarioExporta: [],
    configInput: {
      MAX_CHARTERS: 20000,
    },
  }),
  methods: {
    reset() {
      this.pdf = false;
      this.informacionPaciente = [];
    },
    getInformacion() {
      const BASE_URL = `${this.ip}api/pacientesSelect`;
      axios
        .get(BASE_URL)
        .then((res) => {
          this.pacienteSelect = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    abrirModalGenerarInformeOyL() {
      this.resumen = "";
      this.$modal.show("informeOyL");
    },

    abrirModalGenerarPDF() {
      this.resumen = "";
      this.$modal.show("informe");
    },
    abrirModalGenerarInforme() {
      this.resumen = "";
      this.$modal.show("informeporpaciente");
    },
    cerrarModal() {
      this.$modal.hide("informe");
      this.$modal.hide("informeporpaciente");
      this.$modal.hide("informeOyL");
      this.recomendacion = "";
      this.concepto = "";
    },

    usuarioExportacion() {
      const BASE_URL = `${this.ip}api/usuarioExporta/E.Florez`;
      axios
        .get(BASE_URL)
        .then((res) => {
          this.usuarioExporta = res.data.data[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getInforme() {
      this.$modal.show("carga");
      let BASE_URL = "";
      if (this.informe != 2) {
        BASE_URL = `${this.ip}api/informeEvolucion/${this.paciente}/${this.fechainicio}/${this.fechafin}`;
      } else {
        BASE_URL = `${this.ip}api/informeEvolucion/${this.paciente}/2021-01-01/2021-01-01`;
      }

      axios
        .get(BASE_URL)
        .then((res) => {
          this.indiceAtencion(this.paciente);
          this.informacionPaciente = res.data.paciente;
          this.logo = res.data.CabeceraDef;
          this.cabecera_rosa = res.data.CabeceraDef;
          this.cabecera_oyl = res.data.CabeceraDef;
          // console.log('dx', res.data.dx)

          if (res.data.dx.length > 0) {
            this.dx = res.data.dx;
          }

          if (this.informe == 1) {
            this.terapias = res.data.evoluciones;

            let realizadas = 0;
            let canceladas = 0;
            for (let index = 0; index < res.data.evoluciones.length; index++) {
              if (res.data.evoluciones[index].ProEst == 1) {
                realizadas = realizadas + 1;
              } else {
                canceladas = canceladas + 1;
              }
            }
            this.realizadas = realizadas;
            this.canceladas = canceladas;
          } else if (this.informe == 3) {
            this.objetivos = res.data.objetivos;
          } else {
            this.terapias = [];
            this.canceladas = 0;
            this.realizadas = 0;
          }
          this.pdf = true;
          this.$modal.hide("carga");
        })
        .catch((err) => {
          console.log(err);
          this.$modal.hide("carga");
        });
    },
    indiceAtencion: function (paciente) {
      let fechafin = this.fechamenosdias();
      const BASE_URL = `${this.ip}api/indiceAtencion/${paciente}/${this.fechaActual}/${fechafin}`;
      axios
        .get(BASE_URL)
        .then((res) => {
          this.indice = res.data.indice;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    generateInformePaciente() {
      const CreateTitle = (doc) => {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(17);
        doc.setTextColor(50);
        doc.text(10, 60, `INFORME DE PACIENTE`);
      };
      // primero buscamos la información del terapeuta lider segun la especialidade
      let buscar = "";
      if (this.especialidad == "Psicología") {
        buscar = this.informacionPaciente[0].t_psico;
      } else if (this.especialidad == "Terapia Ocupacional") {
        buscar = this.informacionPaciente[0].t_teo;
      } else if (this.especialidad == "Fonoaudiología") {
        buscar = this.informacionPaciente[0].t_fono;
      } else if (this.especialidad == "Fisioterapia") {
        buscar = this.informacionPaciente[0].t_fisio;
      } else {
        buscar = this.informacionPaciente[0].t_edu;
      }

      // peticion get para la informacion
      if (buscar != null) {
        const BASE_URL = `${this.ip}api/informacionTerapeuta/E.Florez`;
        axios
          .get(BASE_URL)
          .then((res) => {
            const doc = new jsPDF();
            let fecha = new Date();
            let ano = fecha.getFullYear();

            doc.setFont("helvetica", "normal");
            doc.setFontSize(10);
            doc.setTextColor(100);
            doc.text(10, 65, `MES: ${this.mes} del ${ano}`);

            if (this.informacionPaciente[0].url_foto != null) {
              let tipo1 = this.informacionPaciente[0].url_foto.charAt(0);
              let formato1 = "";
              if (tipo1 == "/") {
                formato1 = " jpg";
              } else {
                formato1 = "png";
              }
              doc.addImage(
                this.informacionPaciente[0].url_foto,
                formato1,
                145,
                40,
                50,
                60
              );
            }

            doc.setFontSize(14);
            doc.setTextColor(50);
            doc.text(
              10,
              75,
              `${
                this.informacionPaciente[0].PacNom1 +
                " " +
                this.informacionPaciente[0].PacApe1
              }`
            );

            doc.setFont("helvetica", "bold");
            doc.setFontSize(12);
            doc.setTextColor(50);
            doc.text(10, 85, `Tipo de identificación:`);

            doc.setFont("helvetica", "normal");
            doc.setFontSize(11);
            doc.setTextColor(100);
            doc.text(60, 85, `${this.informacionPaciente[0].tipoDocumento}`);

            doc.setFont("helvetica", "bold");
            doc.setFontSize(12);
            doc.setTextColor(50);
            doc.text(10, 90, `Número de identidad:`);

            doc.setFont("helvetica", "normal");
            doc.setFontSize(11);
            doc.setTextColor(100);
            doc.text(60, 90, `${this.informacionPaciente[0].PacNumDoc}`);

            doc.setFont("helvetica", "bold");
            doc.setFontSize(12);
            doc.setTextColor(50);
            doc.text(10, 95, `Edad:`);

            doc.setFontSize(11);
            doc.setTextColor(100);
            doc.text(
              24,
              95,
              `${this.calcularEdad(this.informacionPaciente[0].PacFecNac)}`
            );

            doc.setFont("helvetica", "bold");
            doc.setFontSize(12);
            doc.setTextColor(100);
            doc.text(
              10,
              270,
              `${
                res.data.data[0].nombres.toUpperCase() +
                " " +
                res.data.data[0].apellidos.toUpperCase()
              }`
            );

            if (res.data.data[0].CamFir1 != null) {
              doc.setFont("helvetica", "normal");
              doc.setFontSize(12);
              doc.setTextColor(50);
              doc.text(10, 275, res.data.data[0].CamFir1.toUpperCase());
            }
            if (res.data.data[0].CamFir2 != null) {
              doc.setFont("helvetica", "normal");
              doc.setFontSize(12);
              doc.setTextColor(50);
              doc.text(10, 280, res.data.data[0].CamFir2.toUpperCase());
            }
            if (res.data.data[0].CamFir3 != null) {
              doc.setFont("helvetica", "normal");
              doc.setFontSize(12);
              doc.setTextColor(50);
              doc.text(10, 285, res.data.data[0].CamFir3.toUpperCase());
            }

            // doc.setFontSize(12);
            // doc.setTextColor(50);
            // doc.text(10, 300, "RECOMENDACIÓN:");

            // let recomendacion = this.recomendacion;
            // let splitdx = doc.splitTextToSize(recomendacion, 190);
            // doc.setFontSize(11);
            // doc.setTextColor(100);
            // doc.text(10, 500, splitdx);

            doc.autoTable({
              margin: { top: 135, left: 10, right: 10 },
              theme: "striped",
              head: [[" Especialidad ", "Concepto", "Terapeuta"]],
              headStyles: {
                overflow: "linebreak",
                fontSize: 12,
                fontStyle: "normal",
                halign: "center",
                valign: "middle",
                fillColor: [48, 36, 84],
              },
              columnStyles: {
                0: { columnWidth: 30, halign: "center" },
                1: { columnWidth: 125 },
                2: { columnWidth: 30, halign: "center" },
              },
              body: [
                [
                  this.especialidad,
                  this.concepto,
                  `${
                    res.data.data[0].nombres + " " + res.data.data[0].apellidos
                  }`,
                ],
              ],
              didDrawPage: (data) => {
                const yFinal = data.cursor.y + 10; // 10px de margen debajo de la tabla

                // Título
                doc.setFont("helvetica", "bold");
                doc.setFontSize(12);
                doc.setTextColor(50);
                doc.text(10, yFinal, "RECOMENDACIÓN:");

                // Texto
                const splitdx = doc.splitTextToSize(this.recomendacion, 245);
                doc.setFont("helvetica", "normal");
                doc.setFontSize(10);
                doc.setTextColor(100);
                doc.text(10, yFinal + 6, splitdx); // deja un pequeño espacio entre título y texto
              },
            });
            doc.setFont("helvetica", "bold");
            doc.setFontSize(12);
            doc.setTextColor(50);
            doc.text(10, 115, "DX:");

            if (this.dx != null) {
              let dx = this.dx;
              let ddx = doc.splitTextToSize(dx, 200);
              doc.setFont("helvetica", "normal");
              doc.setFontSize(11);
              doc.setTextColor(100);
              doc.text(10, 120, ddx);
            }
            CreateTitle(doc);
            addFooters(doc);
            doc.save(
              `informePaciente-${
                this.informacionPaciente[0].PacNom1 +
                "-" +
                this.informacionPaciente[0].PacApe1
              }-${this.mes}.pdf`
            );
            this.crearLogInforme(
              this.paciente,
              "N/A",
              this.recomendacion,
              this.concepto,
              "Informe por paciente"
            );
            this.cerrarModal();
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        alert("No se encontró un lider para esta especialidad");
      }

      const addFooters = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.addImage(this.cabecera_rosa, "png", 0, 0, 210, 40);

          doc.setFontSize(8);
          doc.setTextColor(100);
          doc.text(
            "Pag " + String(i) + " de " + String(pageCount),
            doc.internal.pageSize.width / 2,
            288,
            {
              align: "center",
            }
          );
          doc.setFontSize(8);
          doc.setTextColor(100);
          doc.text(
            "DOCUMENTO CON FIRMA DIGITAL EXPORTADO DESDE AVANTI-ERP",
            doc.internal.pageSize.width / 2,
            293,
            {
              align: "center",
            }
          );
        }
      };
    },
    generarInformePaciente() {
      try {
        const doc = new jsPDF();
        const paciente = this.informacionPaciente[0];
        const headerHeight = 35;
        const footerHeight = 35;
        const pageHeight = doc.internal.pageSize.height;
        const pageWidth = doc.internal.pageSize.getWidth();
        const anchoTexto = 260;
        const lineHeight = 4;

        let startX = 15;
        let startY = headerHeight + 20;
        let logo = this.logo;

        const addHeader = function (doc) {
          doc.addImage(logo, "png", 0, 0, 210, 40);
        };

        const addFooter = function (doc) {
          const fechaTexto = new Date().toLocaleDateString();
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(100);
          doc.text("Avanti", pageWidth / 2, pageHeight - footerHeight + 7, {
            align: "center",
          });
          doc.text(
            `Fecha impresión: ${fechaTexto}`,
            pageWidth / 2,
            pageHeight - footerHeight + 10,
            { align: "center" }
          );
        };

        const checkPageSpace = (yPos, extra = 0) => {
          if (yPos + lineHeight + extra >= pageHeight - footerHeight) {
            doc.addPage();
            addFooter(doc);
            startY = 15;
          }
        };

        function renderJustifiedLine(line, x, y, maxWidth) {
          const newLine = line.replace(/\s+/g, " ");
          const words = newLine.split(" ");
          const wordCount = words.length;

          if (wordCount <= 300) {
            doc.text(line, x, y, { maxWidth: 180 });
            return;
          }

          const totalWordsWidth = words.reduce(
            (total, word) => total + doc.getTextWidth(word),
            0
          );
          const spaceWidth = (maxWidth - totalWordsWidth) / (wordCount - 1);
          let currentX = x;

          words.forEach((word, index) => {
            doc.text(word, currentX, y);
            if (index < wordCount - 1) {
              currentX += doc.getTextWidth(word) + spaceWidth;
            }
          });
        }

        const renderJustifiedText = (text) => {
          const lines = doc.splitTextToSize(text, anchoTexto);
          lines.forEach((line) => {
            checkPageSpace(startY);
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(100);
            renderJustifiedLine(line, startX, startY, anchoTexto);
            startY += lineHeight;
          });
        };

        const addSignature = async (doc) => {
          let firmas = [];
          firmas.push(this.usuarioExporta);
          const imageWidth = 60;
          const imageHeight = 15;
          const margin = 5;
          let yPosition = startY;
          const todasFirmas = [...firmas];

          todasFirmas.forEach((imageData) => {
            console.log(footerHeight, "footer");
            if (imageData.CamFir1 == null || imageData.CamFir1 == "") {
              return "ERROR";
            }

            const xPosition = pageWidth / 2;
            if (yPosition + imageHeight + margin + footerHeight > pageHeight) {
              doc.addPage();
              yPosition = 15;
              addFooter(doc);
            }
            // doc.addImage(
            //   imageData,
            //   "PNG",
            //   xPosition,
            //   yPosition,
            //   imageWidth,
            //   imageHeight
            // );

            const nombreTerapeuta =
              imageData.nombres + " " + imageData.apellidos;
            doc.setFontSize(12);
            doc.setFont("helvetica", "bold");
            doc.setTextColor("#000000");
            doc.text(
              nombreTerapeuta.toUpperCase(),
              xPosition,
              yPosition + imageHeight + 5,
              {
                align: "center",
              }
            );
            yPosition += 5 + 0;
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(100);
            doc.text(
              imageData.CamFir1,
              xPosition,
              yPosition + imageHeight + 5,
              {
                align: "center",
              }
            );
            if (imageData.CamFir2 != null) {
              yPosition += 6 + 0;
              doc.setFontSize(10);
              doc.setFont("helvetica", "normal");
              doc.setTextColor(100);
              doc.text(
                imageData.CamFir2,
                xPosition,
                yPosition + imageHeight + 5,
                {
                  align: "center",
                }
              );
            }
            if (imageData.CamFir3 != null) {
              yPosition += 6 + 0;
              doc.setFontSize(8);
              doc.setFont("helvetica", "normal");
              doc.setTextColor(100);
              doc.text(
                imageData.CamFir3,
                xPosition,
                yPosition + imageHeight + 5,
                {
                  align: "center",
                }
              );
            }
            yPosition += imageHeight + margin;
          });
        };

        addHeader(doc);
        addFooter(doc);

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor("#000000");
        doc.text("INFORME POR PACIENTE", pageWidth / 2, startY, {
          align: "center",
        });
        startY += 5;

        const tableData = [
          [
            {
              content: "NOMBRE DEL PACIENTE",
              styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
            },
            {
              content: `${paciente.PacNom1} ${paciente.PacApe1}`,
              styles: { fontSize: 10 },
              colSpan: 3,
            },
          ],
          [
            {
              content: "FECHA DE NACIMIENTO",
              styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
            },
            {
              content: paciente.PacFecNac,
              styles: { fontSize: 10 },
            },
            {
              content: "EDAD:",
              styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
            },
            {
              content: this.calcularEdad(paciente.PacFecNac),
              styles: { fontSize: 10 },
            },
          ],
          [
            {
              content: "NUMERO DE DOCUMENTO",
              styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
            },
            {
              content: parseFloat(paciente.PacNumDoc).toLocaleString("es-ES"),
              styles: { fontSize: 10 },
              colSpan: 3,
            },
          ],
          [
            {
              content: "DIAGNÓSTICO (S) MÉDICO (S):",
              styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
            },
            {
              content:
                paciente.PacDia != null ? paciente.PacDia : "Sin diagnóstico",
              styles: { fontSize: 10 },
              colSpan: 3,
            },
          ],
          [
            {
              content: "ESPECIALIDAD",
              styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
            },
            {
              content: this.especialidad.toUpperCase(),
              styles: { fontSize: 10 },
              colSpan: 3,
            },
          ],
          [
            {
              content: "MES DEL INFORME",
              styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
            },
            {
              content: this.mes.toUpperCase(),
              styles: { fontSize: 10 },
              colSpan: 3,
            },
          ]
        ];
        doc.autoTable({
          startY: startY,
          theme: "grid",
          body: tableData,
          margin: { top: headerHeight + 15, bottom: footerHeight + 20 },
          styles: {
            fontSize: 10,
            cellPadding: { top: 2, bottom: 2, left: 2, right: 2 },
          },
          pageBreak: "auto",
        });

        startY = doc.lastAutoTable.finalY + 10;

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor("#000000");
        doc.text("CONCEPTO", pageWidth / 2, startY, {
          align: "center",
        });

        startY += 8;
        renderJustifiedText(this.concepto);

        checkPageSpace(startY);
        startY += 8;

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor("#000000");
        doc.text("RECOMENDACIONES", pageWidth / 2, startY, {
          align: "center",
        });

        startY += 8;
        renderJustifiedText(this.recomendacion);
        startY += 8;
        checkPageSpace(startY);
        addSignature(doc);

        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          const pageLabel = `Pag ${i} de ${pageCount}`;
          const textWidth = doc.getTextWidth(pageLabel);
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(100);
          doc.text(
            pageLabel,
            (pageWidth - textWidth) / 2,
            pageHeight - footerHeight + 13
          );
        }

        doc.save(`informe-paciente-${paciente.PacNom1}-${paciente.PacApe1}.pdf`);
        this.cerrarModal();

      } catch (error) {
        console.log(error);
      }
    },
    generatePDFOyL() {
      const addFooters = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.addImage(this.cabecera_oyl, "png", 0, 0, 300, 40);

          doc.setFontSize(8);
          doc.setTextColor(50);
          doc.text(
            "Pag " + String(i) + " de " + String(pageCount),
            doc.internal.pageSize.width / 2,
            202,
            {
              align: "center",
            }
          );
          doc.setFontSize(8);
          doc.setTextColor(50);
          doc.text(
            "DOCUMENTO EXPORTADO DESDE AVANTI-ERP",
            doc.internal.pageSize.width / 2,
            207,
            {
              align: "center",
            }
          );

          doc.setFontSize(14);
          doc.setTextColor(50);
          doc.text(
            10,
            70,
            `${
              this.informacionPaciente[0].PacNom1 +
              " " +
              this.informacionPaciente[0].PacApe1
            }`
          );

          doc.setFontSize(11);
          doc.setTextColor(50);
          doc.text(
            10,
            75,
            `${this.calcularEdad(this.informacionPaciente[0].PacFecNac)}`
          );

          doc.setFontSize(12);
          doc.setTextColor(50);
          doc.text(10, 85, "DE:");

          doc.setFontSize(11);
          doc.setTextColor(100);
          doc.text(19, 85, this.fechainicio);

          doc.setFontSize(12);
          doc.setTextColor(50);
          doc.text(10, 90, "HASTA:");

          doc.setFontSize(11);
          doc.setTextColor(100);
          doc.text(26, 90, this.fechafin);

          doc.setFontSize(12);
          doc.setTextColor(50);
          doc.text(10, 95, "ESPECIALIDADES:");

          doc.setFontSize(11);
          doc.setTextColor(100);
          doc.text(48, 95, "Todas");

          doc.setFontSize(12);
          doc.setTextColor(50);
          doc.text(225, 70, "ÍNDICE DE ATENCIÓN:");

          doc.setFontSize(12);
          doc.setTextColor(100);
          doc.text(272, 70, `${this.indice.toFixed(0)}%`);

          doc.setFontSize(12);
          doc.setTextColor(50);
          doc.text(10, 100, "RESUMEN:");

          let resumen = this.resumen;
          let splitResumen = doc.splitTextToSize(resumen, 300);
          doc.setFontSize(11);
          doc.setTextColor(100);
          doc.text(10, 105, splitResumen);

          const CreateTitle = (doc, text) => {
            doc.setFont(undefined, "bold");
            doc.setFontSize(19);
            doc.setTextColor(50);
            doc.text(237, 60, `INFORME OYL`);
          };

          CreateTitle(doc);
        }
      };
      const doc = new jsPDF("landscape");

      doc.autoTable({
        theme: "css",
        html: "#objetivoss",
        headStyles: {
          overflow: "linebreak",
          fontSize: 10,
          fontStyle: "normal",
          halign: "center", // left, center, right
          valign: "middle", // top, middle, bottom
          fillColor: [48, 36, 84],
        },
        margin: { top: 142, left: 10, right: 10 },
        theme: "striped",
      });

      addFooters(doc);
      doc.save(`informeOyL-${this.informacionPaciente[0].PacNom1}.pdf`);
      this.crearLogInforme(
        this.paciente,
        this.resumen,
        "N/A",
        "N/A",
        "Informe de objetivos y logros"
      );
      this.cerrarModal();
    },
    generarInformeDeEvolucion: function () {
      try {
        const doc = new jsPDF();
        const paciente = this.informacionPaciente[0];
        const headerHeight = 35;
        const footerHeight = 35;
        const pageHeight = doc.internal.pageSize.height;
        const pageWidth = doc.internal.pageSize.getWidth();
        const anchoTexto = 260;
        const lineHeight = 4;

        let startX = 15;
        let startY = headerHeight + 20;
        let logo = this.logo;

        const addHeader = function (doc) {
          doc.addImage(logo, "png", 0, 0, 210, 40);
        };

        const addFooter = function (doc) {
          const fechaTexto = new Date().toLocaleDateString();
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(100);
          doc.text("Avanti", pageWidth / 2, pageHeight - footerHeight + 7, {
            align: "center",
          });
          doc.text(
            `Fecha impresión: ${fechaTexto}`,
            pageWidth / 2,
            pageHeight - footerHeight + 10,
            { align: "center" }
          );
        };

        const checkPageSpace = (yPos, extra = 0) => {
          if (yPos + lineHeight + extra >= pageHeight - footerHeight) {
            doc.addPage();
            addFooter(doc);
            startY = 15;
          }
        };

        function renderJustifiedLine(line, x, y, maxWidth) {
          const newLine = line.replace(/\s+/g, " ");
          const words = newLine.split(" ");
          const wordCount = words.length;

          if (wordCount <= 300) {
            doc.text(line, x, y);
            return;
          }

          const totalWordsWidth = words.reduce(
            (total, word) => total + doc.getTextWidth(word),
            0
          );
          const spaceWidth = (maxWidth - totalWordsWidth) / (wordCount - 1);
          let currentX = x;

          words.forEach((word, index) => {
            doc.text(word, currentX, y);
            if (index < wordCount - 1) {
              currentX += doc.getTextWidth(word) + spaceWidth;
            }
          });
        }

        const renderJustifiedText = (text) => {
          const lines = doc.splitTextToSize(text, anchoTexto);
          lines.forEach((line) => {
            checkPageSpace(startY);
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(100);
            renderJustifiedLine(line, startX, startY, anchoTexto);
            startY += lineHeight;
          });
        };

        const addSignature = async (doc) => {
          let firmas = [];
          firmas.push(this.usuarioExporta);
          const imageWidth = 60;
          const imageHeight = 15;
          const margin = 5;
          let yPosition = startY;
          const todasFirmas = [...firmas];

          todasFirmas.forEach((imageData) => {
            console.log(footerHeight, "footer");
            if (imageData.CamFir1 == null || imageData.CamFir1 == "") {
              return "ERROR";
            }

            const xPosition = pageWidth / 2;
            if (yPosition + imageHeight + margin + footerHeight > pageHeight) {
              doc.addPage();
              yPosition = 15;
              addFooter(doc);
            }
            // doc.addImage(
            //   imageData,
            //   "PNG",
            //   xPosition,
            //   yPosition,
            //   imageWidth,
            //   imageHeight
            // );

            const nombreTerapeuta =
              imageData.nombres + " " + imageData.apellidos;
            doc.setFontSize(12);
            doc.setFont("helvetica", "bold");
            doc.setTextColor("#000000");
            doc.text(
              nombreTerapeuta.toUpperCase(),
              xPosition,
              yPosition + imageHeight + 5,
              {
                align: "center",
              }
            );
            yPosition += 5 + 0;
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(100);
            doc.text(
              imageData.CamFir1,
              xPosition,
              yPosition + imageHeight + 5,
              {
                align: "center",
              }
            );
            if (imageData.CamFir2 != null) {
              yPosition += 6 + 0;
              doc.setFontSize(10);
              doc.setFont("helvetica", "normal");
              doc.setTextColor(100);
              doc.text(
                imageData.CamFir2,
                xPosition,
                yPosition + imageHeight + 5,
                {
                  align: "center",
                }
              );
            }
            if (imageData.CamFir3 != null) {
              yPosition += 6 + 0;
              doc.setFontSize(8);
              doc.setFont("helvetica", "normal");
              doc.setTextColor(100);
              doc.text(
                imageData.CamFir3,
                xPosition,
                yPosition + imageHeight + 5,
                {
                  align: "center",
                }
              );
            }
            yPosition += imageHeight + margin;
          });
        };

        addHeader(doc);
        addFooter(doc);

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor("#000000");
        doc.text("INFORME DE EVOLUCIÓN", pageWidth / 2, startY, {
          align: "center",
        });
        startY += 5;

        const tableData = [
          [
            {
              content: "NOMBRE DEL PACIENTE",
              styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
            },
            {
              content: `${paciente.PacNom1} ${paciente.PacApe1}`,
              styles: { fontSize: 10 },
              colSpan: 3,
            },
          ],
          [
            {
              content: "FECHA DE NACIMIENTO",
              styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
            },
            {
              content: paciente.PacFecNac,
              styles: { fontSize: 10 },
            },
            {
              content: "EDAD:",
              styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
            },
            {
              content: this.calcularEdad(paciente.PacFecNac),
              styles: { fontSize: 10 },
            },
          ],
          [
            {
              content: "NUMERO DE DOCUMENTO",
              styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
            },
            {
              content: parseFloat(paciente.PacNumDoc).toLocaleString("es-ES"),
              styles: { fontSize: 10 },
              colSpan: 3,
            },
          ],
          [
            {
              content: "DIAGNÓSTICO (S) MÉDICO (S):",
              styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
            },
            {
              content:
                paciente.PacDia != null ? paciente.PacDia : "Sin diagnóstico",
              styles: { fontSize: 10 },
              colSpan: 3,
            },
          ],
          [
            {
              content: "ESPECIALIDAD",
              styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
            },
            {
              content: this.especialidadEvo,
              styles: { fontSize: 10 },
              colSpan: 3,
            },
          ],
          [
            {
              content: "FECHAS",
              styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
            },
            {
              content: `${ this.fechainicio } - ${ this.fechafin }`,
              styles: { fontSize: 10 },
              colSpan: 3,
            },
          ],
        ];
        doc.autoTable({
          startY: startY,
          theme: "grid",
          body: tableData,
          margin: { top: headerHeight + 15, bottom: footerHeight + 20 },
          styles: {
            fontSize: 10,
            cellPadding: { top: 2, bottom: 2, left: 2, right: 2 },
          },
          pageBreak: "auto",
        });

        startY = doc.lastAutoTable.finalY + 10;

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor("#000000");
        doc.text("RESUMEN", pageWidth / 2, startY, {
          align: "center",
        });

        startY += 8;
        renderJustifiedText(this.resumen);

        startY += 10;

        checkPageSpace(startY);
        addSignature(doc);

        startY += 10;
        doc.autoTable({
          startY: startY,
          theme: "grid",
          html: "#mi-table",
          headStyles: {
            fillColor: [48, 36, 84],
          },
          margin: { top: headerHeight + 25, bottom: footerHeight + 20 },
          styles: {
            fontSize: 10,
            cellPadding: { top: 2, bottom: 2, left: 2, right: 2 },
          },
          pageBreak: "auto",
        });

        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          const pageLabel = `Pag ${i} de ${pageCount}`;
          const textWidth = doc.getTextWidth(pageLabel);
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(100);
          doc.text(
            pageLabel,
            (pageWidth - textWidth) / 2,
            pageHeight - footerHeight + 13
          );
        }

        doc.save(`informe-de-evolucion-${paciente.PacNom1}-${paciente.PacApe1}.pdf`);
          this.crearLogInforme(
          this.paciente,
          this.resumen,
          "N/A",
          "N/A",
          "Informe de evolución"
        );
        this.cerrarModal();
      } catch (error) {
        console.log(error);
      }
    },
    calcularEdad(fecha) {
      var fechaNacimiento = fecha;
      var values = fechaNacimiento.split("-");
      var dia = values[2];
      var mes = values[1];
      var ano = values[0];

      var fecha_hoy = new Date();
      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      // this.fechaIngreso = fechaActual;

      var edad = ahora_ano + 0 - ano;
      if (ahora_mes < mes) {
        edad--;
      }
      if (mes == ahora_mes && ahora_dia < dia) {
        edad--;
      }
      if (edad > 1900) {
        edad -= 1900;
      }

      // calculamos los meses
      var meses = 0;
      if (ahora_mes > mes) meses = ahora_mes - mes;
      if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
      if (ahora_mes == mes && dia > ahora_dia) meses = 11;

      // calculamos los dias
      var dias = 0;
      if (ahora_dia > dia) dias = ahora_dia - dia;
      if (ahora_dia < dia) {
        var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
        var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
      }

      // this.anos = edad;
      // this.meses = meses;
      return `${edad} año(s) y ${meses} mes(es)`;
    },
    fechamenosdias: function () {
      var fecha = new Date();
      fecha.setDate(fecha.getDate() - 90);
      // console.log("fecha menos 7 días", fecha);

      var fechaFormateada = "";
      var ahora_ano = fecha.getFullYear();
      var ahora_mes = fecha.getMonth() + 1;
      var ahora_dia = fecha.getDate();
      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
      return fechaFormateada;
    },
    calcularFechaActual() {
      var mes;
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },
    crearLogInforme(paciente, resumen, recomendacion, concepto, informe_tipo) {
      const BASE_URL = `${this.ip}api/log-informe`;
      const data = {
        entrega: localStorage.getItem("usuario"),
        paciente: paciente,
        informe_tipo: informe_tipo,
        resumen: resumen,
        recomendacion: recomendacion,
        concepto: concepto,
      };
      axios
        .post(BASE_URL, data)
        .then((res) => {
          console.log("Log creado:", res.data);
        })
        .catch((err) => {
          console.error("Error creando log:", err);
        });
    },
  },
  mounted() {
    this.getInformacion();
    this.calcularFechaActual();
    this.fechamenosdias();
    this.usuarioExportacion();
  },
};
</script>
<style scoped>
.banner {
  height: 50px !important;
  width: 100%;
  background-color: red;
}
.modal-content {
  width: 100% !important;
  position: absolute !important;
}

.titulo-modal {
  padding: 0px !important;
  margin: 0px !important;
}

.texto-pequeno {
  font-size: 15px;
  color: darkgray;
  padding: 0px !important;
  margin: 0px !important;
}

.d-none {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Reportes/InformeEvolucion.vue